/* Startseite (04.10.2026): Liefer-Zeitachse (Datum + Animation) und Punkte der Wisch-Karten.
   Die Datumsfunktionen kommen aus ea-eta.js, derselben Datei wie auf der Produktseite. */
(function () {
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* Datumsfunktionen: assets/ea-eta.js (window.EaEta), gemeinsam mit der Produktseite. */

  function initEta(el) {
    if (el.getAttribute('data-eh-ready') === '1') return;
    el.setAttribute('data-eh-ready', '1');
    var min = parseInt(el.getAttribute('data-eta-min'), 10);
    var max = parseInt(el.getAttribute('data-eta-max'), 10);
    var cutoff = parseInt(el.getAttribute('data-eta-cutoff'), 10) || 0;
    var out = el.querySelector('[data-eta-date]');
    var eta = window.EaEta;
    if (eta && out && min > 0 && max >= min) {
      try {
        var now = new Date(), r = eta.range(now, min, max, cutoff);
        out.textContent = eta.label(r[0], r[1]);
        var ship = el.querySelector('[data-eta-ship]'), sd = eta.shipDay(now, cutoff);
        if (ship && sd) ship.textContent = eta.shipLabel(sd);
      } catch (e) { /* Fallback-Text aus Liquid bleibt stehen */ }
    }
    var fill = function () { el.classList.remove('is-pending'); };
    if (reduce.matches || !('IntersectionObserver' in window)) { fill(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { fill(); io.disconnect(); } });
    }, { threshold: 0.6 });
    io.observe(el);
  }

  /* Punkte unter den Wisch-Karten: markiert die Karte, die gerade links anliegt. */
  function initDots(track) {
    if (track.getAttribute('data-eh-ready') === '1') return;
    track.setAttribute('data-eh-ready', '1');
    var dots = all('[data-eh-dots="' + track.id + '"] i');
    if (!dots.length) return;
    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        raf = 0;
        var items = track.children, best = 0, bestDist = Infinity, left = track.getBoundingClientRect().left;
        for (var i = 0; i < items.length; i++) {
          var d = Math.abs(items[i].getBoundingClientRect().left - left - 18);
          if (d < bestDist) { bestDist = d; best = i; }
        }
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) best = items.length - 1;
        dots.forEach(function (dot, i) { dot.classList.toggle('is-on', i === best); });
      });
    }, { passive: true });
  }

  function boot(scope) {
    all('[data-eh-eta]', scope).forEach(initEta);
    all('[data-eh-track]', scope).forEach(initDots);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
